import React from "react";
import {
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
  Portal,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Box,
} from "@chakra-ui/react";
import { FaRegQuestionCircle } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const P = "features.InvestmentScreening.Popover.rationalizationImprovement";
const C = "common.label";

interface Props {
  isSimpleMode?: boolean;
}

/**
 * 合理化による改善効果の項目説明ポップオーバー
 *
 * 使用例:
 * <RationalizationImprovementExplanationPopover isSimpleMode={isSimpleMode} />
 */
export const RationalizationImprovementExplanationPopover: React.FC<Props> = ({ isSimpleMode = false }) => {
  const { t } = useTranslation();
  return (
    <Popover placement="right">
      <PopoverTrigger>
        <button style={{ background: 'none', border: 'none', padding: 0 }}>
          <FaRegQuestionCircle size="30px" cursor="pointer" />
        </button>
      </PopoverTrigger>
      <Portal>
        <PopoverContent width="800px" maxH="600px" overflowY="auto" bgColor="#fffff0">
          <PopoverArrow />
          <PopoverCloseButton />
          <PopoverHeader fontWeight="bold">{t(`${P}.title`)}</PopoverHeader>
          <PopoverBody>
            <Box mb={4}>
              <Table size="sm" variant="simple">
                <Thead>
                  <Tr>
                    <Th w="150px">{t(`${C}.columnName`)}</Th>
                    <Th>{t(`${C}.description`)}</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  <Tr>
                    <Td fontWeight="bold">{t(`${P}.beforeName`)}</Td>
                    <Td>{t(`${P}.beforeDesc`)}</Td>
                  </Tr>
                  <Tr>
                    <Td fontWeight="bold">{t(`${P}.afterName`)}</Td>
                    <Td>{t(`${P}.afterDesc`)}</Td>
                  </Tr>
                </Tbody>
              </Table>
            </Box>

            <Box mb={4}>
              <Table size="sm" variant="simple">
                <Thead>
                  <Tr>
                    <Th w="60px">{t(`${C}.no`)}</Th>
                    <Th w="180px">{t(`${C}.indicatorItem`)}</Th>
                    <Th>{t(`${C}.description`)}</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  <Tr>
                    <Td>1</Td>
                    <Td fontWeight="bold">{t(`${P}.productionCountName`)}</Td>
                    <Td>{t(`${P}.productionCountDesc`)}</Td>
                  </Tr>
                  {isSimpleMode && (
                    <Tr>
                      <Td>2</Td>
                      <Td fontWeight="bold">{t(`${P}.quantityName`)}</Td>
                      <Td>{t(`${P}.quantityDesc`)}</Td>
                    </Tr>
                  )}
                  <Tr>
                    <Td>-</Td>
                    <Td fontWeight="bold">{t(`${P}.customItemName`)}</Td>
                    <Td>{t(`${P}.customItemIndicatorDesc`)}</Td>
                  </Tr>
                </Tbody>
              </Table>
            </Box>

            <Box>
              <Table size="sm" variant="simple">
                <Thead>
                  <Tr>
                    <Th w="60px">{t(`${C}.no`)}</Th>
                    <Th w="180px">{t(`${C}.costItem`)}</Th>
                    <Th>{t(`${C}.description`)}</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  <Tr>
                    <Td>1</Td>
                    <Td fontWeight="bold">{t(`${P}.laborCostName`)}</Td>
                    <Td>{t(`${P}.laborCostDesc`)}</Td>
                  </Tr>
                  <Tr>
                    <Td>2</Td>
                    <Td fontWeight="bold">{t(`${P}.repairCostName`)}</Td>
                    <Td>{t(`${P}.repairCostDesc`)}</Td>
                  </Tr>
                  <Tr>
                    <Td>3</Td>
                    <Td fontWeight="bold">{t(`${P}.consumablesCostName`)}</Td>
                    <Td>{t(`${P}.consumablesCostDesc`)}</Td>
                  </Tr>
                  <Tr>
                    <Td>4</Td>
                    <Td fontWeight="bold">{t(`${P}.maintenanceCostName`)}</Td>
                    <Td>{t(`${P}.maintenanceCostDesc`)}</Td>
                  </Tr>
                  <Tr>
                    <Td>5</Td>
                    <Td fontWeight="bold">{t(`${P}.scrapCostName`)}</Td>
                    <Td>{t(`${P}.scrapCostDesc`)}</Td>
                  </Tr>
                  <Tr>
                    <Td>6</Td>
                    <Td fontWeight="bold">{t(`${P}.equipmentDepreciationName`)}</Td>
                    <Td>{t(`${P}.equipmentDepreciationDesc`)}</Td>
                  </Tr>
                  <Tr>
                    <Td>7</Td>
                    <Td fontWeight="bold">{t(`${P}.otherDepreciationName`)}</Td>
                    <Td>{t(`${P}.otherDepreciationDesc`)}</Td>
                  </Tr>
                  <Tr>
                    <Td>-</Td>
                    <Td fontWeight="bold">{t(`${P}.customItemName`)}</Td>
                    <Td>{t(`${P}.customItemCostDesc`)}</Td>
                  </Tr>
                </Tbody>
              </Table>
            </Box>
          </PopoverBody>
        </PopoverContent>
      </Portal>
    </Popover>
  );
};
